import { FormControl, FormHelperText, FormLabel, OutlinedInput } from '@mui/material';
import { Field } from 'formik';
import PropTypes from 'prop-types';

export default function TextInputField({ name, id, label, helperText, disabled, error, multiline, placeholder }) {
  return (
    <Field name={name}>
      {({ field }) => (
        <FormControl disabled={disabled} error={error}>
          <FormLabel htmlFor={id ?? field.name}>{label}</FormLabel>
          <OutlinedInput
            id={id ?? field.name}
            aria-labelledby={id ?? field.name}
            name={field.name}
            value={field.value}
            onChange={field.onChange}
            multiline={multiline}
            {...(placeholder && { placeholder })}
            {...(multiline && { inputComponent: 'textarea', rows: 4 })}
          />
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    </Field>
  );
}

TextInputField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  multiline: PropTypes.bool,
  placeholder: PropTypes.string,
};
